import React from 'react'
import Alert from "react-bootstrap/Alert"
import { NavLink, Redirect } from "react-router-dom"

import Constants, { appConfig } from '../../config.js'
import { UserContext } from "../../Contexts/UserContext/UserContext.js"
import { getLog } from '../../helpers/helpers.js'
import PasswordStrengthMeter from '../../components/PasswordStrengthMeter.js'
import PasswordGenerator from '../../components/PasswordGenerator.js'
import BackupChoiceModal from '../../components/BackupChoiceModal.js'

import './wallet_password.css'
import { ButtonPrimary, ButtonPrimaryOutlined } from '../../components/Buttons.js'



// TODO convert into functional component
class Wallet_Password extends React.Component {

    static contextType = UserContext;

    constructor(props) {
        super(props);
        this.classname = "Wallet_Password: "

        this.state = {
            redirect: false,
            mnemonic: "",
            filename: "TokkenR_wallet_",
            extension: "." + appConfig.name.toLowerCase(),
            password: "",
            password_confirmation: "",
            validpassword: false,
            validpassword_confirmation: false,
            validpassword_notempty: false,
            rememberDevice: false,    // opt-in: store encrypted blob in localStorage
            showPassword: false,      // eye-icon toggle for the password fields
            showConfirmPassword: false,
            showBackupModal: false,   // BackupChoiceModal visibility
            passwordWasGenerated: false, // tracks if password came from the generator
        }

        this.componentDidMount = this.componentDidMount.bind(this)
        this.handleChange_password = this.handleChange_password.bind(this)
        this.handleChange_password_confirmation = this.handleChange_password_confirmation.bind(this)
        this.handleChange_rememberDevice = this.handleChange_rememberDevice.bind(this)
        this.is_confirmation_valid = this.is_confirmation_valid.bind(this)
        this.is_password_valid = this.is_password_valid.bind(this)
        this.handleKeyDown = this.handleKeyDown.bind(this)
        this.handleContinue = this.handleContinue.bind(this)
        this.toggleShowPassword = this.toggleShowPassword.bind(this)
        this.toggleShowConfirmPassword = this.toggleShowConfirmPassword.bind(this)
        this.handleGeneratedPassword = this.handleGeneratedPassword.bind(this)
        this.handleBackupComplete = this.handleBackupComplete.bind(this)
    }


    componentDidMount() {
        this.setState({
            mnemonic: this.context.pending_wallet ? this.context.pending_wallet.mnemonic : "",
        })
    }


    handleKeyDown(e) {
        if (e.key === 'Enter') {
            if (this.is_password_valid(this.state.password) && this.is_confirmation_valid()) {
                this.handleContinue()
            }
        }
    }


    handleChange_rememberDevice(e) {
        this.setState({ rememberDevice: e.target.checked })
    }

    toggleShowPassword() {
        this.setState({ showPassword: !this.state.showPassword })
    }

    toggleShowConfirmPassword() {
        this.setState({ showConfirmPassword: !this.state.showConfirmPassword })
    }

    handleGeneratedPassword(generatedPassword) {
        this.setState({
            password: generatedPassword,
            showPassword: true,
            validpassword: generatedPassword.length > 0,
            validpassword_notempty: true,
            validpassword_confirmation: false,
            password_confirmation: "",
            passwordWasGenerated: true,
        })
    }

    is_confirmation_valid() {
        return this.state.password == this.state.password_confirmation
    }


    handleChange_password_confirmation(event) {
        var password_confirmation = event.target.value

        this.setState({
            password_confirmation: password_confirmation,
            validpassword_confirmation: false,
        }, () => {
            const is_confirmation_valid = this.is_confirmation_valid()
            this.setState({ validpassword_confirmation: is_confirmation_valid })
        })
    }

    is_password_valid(currpassword) {
        // advisory-only: the only requirement is that the field is non-empty.
        // Strength is shown via PasswordStrengthMeter but never blocks.
        if (currpassword.length > 0) {
            return true
        } else {
            return false
        }
    }

    handleChange_password(event) {
        var currpassword = event.target.value

        this.setState({
            password: currpassword,
            validpassword: false,
            validpassword_confirmation: false,
            validpassword_notempty: false,
            // if the user manually edits the password after generating one,
            // mark it as no longer generated (so the verify step won't show)
            passwordWasGenerated: false,
        }, () => {
            const is_valid = this.is_password_valid(currpassword)
            this.setState({
                validpassword: is_valid,
                validpassword_confirmation: this.is_confirmation_valid(),
                validpassword_notempty: this.state.password.length > 0,
            })
        })
    }


    /**
     * Opens the BackupChoiceModal instead of directly downloading.
     * The modal handles the download / skip / verify flow, then calls
     * handleBackupComplete which saves the session blob + redirects.
     */
    handleContinue(event = null) {
        if (event) event.preventDefault()

        if (!this.is_password_valid(this.state.password) || !this.is_confirmation_valid()) {
            return
        }

        this.setState({ showBackupModal: true })
    }


    /**
     * Called by BackupChoiceModal when the user is done (either downloaded
     * a backup or skipped). Handles saving the session blob + redirect.
     */
    async handleBackupComplete(downloaded) {
        const function_id = this.classname + "handleBackupComplete(): "
        const log = getLog(function_id)

        this.setState({ showBackupModal: false })

        if (downloaded) {
            log("user downloaded backup file")
        } else {
            log("user skipped backup file download")
        }

        // Atomically commit the pending wallet into real state via
        // commit_wallet (which calls update_from_mnemonic_noreload +
        // saves the session blob + clears pending_wallet + flow flag).
        if (this.context.pending_wallet && this.context.pending_wallet.mnemonic) {
            await this.context.commit_wallet(
                this.state.password,
                this.state.rememberDevice
            )
        }

        // Redirect to the wallet
        this.setState({ redirect: true })
    }


    render() {
        if (this.state.redirect === true) {
            return (
                <Redirect to="/wallet" push />
            )
        }

        // Flow enforcement: if there's no pending_wallet with a walletname,
        // the user got here without completing the previous steps. Redirect
        // to /select_wallet to restart the flow.
        if (!this.context.pending_wallet || !this.context.pending_wallet.walletname) {
            return <Redirect to="/select_wallet" push />
        }

        var nextbuttonstyle = {}

        if (!this.state.validpassword || !this.state.validpassword_confirmation) {
            nextbuttonstyle = { pointerEvents: "none", backgroundColor: "gray" }
        }

        return (
            <div className="mode-selection-style">
                <h2>
                    {Constants.PASSWORD_TITLE}
                </h2>
                <br />

                <p className="main-text-page">
                    {Constants.PASSWORD_INFO}
                </p>
                <br />

                <Alert variant="warning" style={{ fontSize: "18px" }}>
                    <i className="fa fa-info-circle" style={{ fontSize: "24px" }} /> &nbsp;
                    {Constants.PASSWORD_WARN}
                </Alert>
                <br />

                {/* Form to complete */}

                <div className="main-text-page">
                    <div className="input_style" style={{ marginLeft: "2.5em" }}>
                        <div>
                            {/* Password field with eye-icon toggle */}
                            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                <input
                                    type={this.state.showPassword ? "text" : "password"}
                                    value={this.state.password}
                                    onChange={this.handleChange_password}
                                    onKeyDown={this.handleKeyDown}
                                    id="psw" name="psw"
                                    placeholder="Type your password"
                                    style={{ width: "30em" }}
                                />
                                <button
                                    type="button"
                                    onClick={this.toggleShowPassword}
                                    style={{
                                        background: "none", border: "none", cursor: "pointer",
                                        fontSize: "18px", color: "inherit", padding: "2px 4px",
                                    }}
                                    title={this.state.showPassword ? "Hide" : "Show"}
                                >
                                    <i className={"fas " + (this.state.showPassword ? "fa-eye-slash" : "fa-eye")} />
                                </button>
                            </div>

                            {/* Strength meter (advisory-only, never blocks) */}
                            <div style={{ width: "30em", marginTop: "4px" }}>
                                <PasswordStrengthMeter password={this.state.password} />
                            </div>

                            {/* Password generator */}
                            <PasswordGenerator onGenerate={this.handleGeneratedPassword} />

                            <br />
                            {/* Confirm password field with eye-icon toggle */}
                            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                <input
                                    type={this.state.showConfirmPassword ? "text" : "password"}
                                    value={this.state.password_confirmation}
                                    onChange={this.handleChange_password_confirmation}
                                    onKeyDown={this.handleKeyDown}
                                    id="psw" name="psw"
                                    placeholder="Type it again to confirm"
                                    style={{
                                        width: "30em",
                                        ...(this.state.password_confirmation.length > 0 && !this.state.validpassword_confirmation
                                            ? { border: "1px solid red" }
                                            : {}),
                                    }}
                                />
                                <button
                                    type="button"
                                    onClick={this.toggleShowConfirmPassword}
                                    style={{
                                        background: "none", border: "none", cursor: "pointer",
                                        fontSize: "18px", color: "inherit", padding: "2px 4px",
                                    }}
                                    title={this.state.showConfirmPassword ? "Hide" : "Show"}
                                >
                                    <i className={"fas " + (this.state.showConfirmPassword ? "fa-eye-slash" : "fa-eye")} />
                                </button>
                            </div>

                            {/* Inline validation message for confirm password */}
                            {this.state.password_confirmation.length > 0 && !this.state.validpassword_confirmation ? (
                                <p style={{ color: "red", fontSize: "14px", margin: "4px 0 0 0", width: "30em" }}>
                                    Passwords do not match
                                </p>
                            ) : null}
                        </div>
                    </div>
                </div>

                {/* Remember device option */}
                <div className="main-text-page" style={{ maxWidth: "500px", margin: "0 auto" }}>
                    <Alert variant="secondary" style={{ fontSize: "16px", textAlign: "left" }}>
                        <label style={{ cursor: "pointer", display: "flex", alignItems: "flex-start", gap: "8px" }}>
                            <input
                                type="checkbox"
                                checked={this.state.rememberDevice}
                                onChange={this.handleChange_rememberDevice}
                                style={{ marginTop: "4px", transform: "scale(1.3)" }}
                            />
                            <span>
                                <b>{Constants.REMEMBER_DEVICE_QUESTION}</b><br />
                                <span style={{ fontSize: "14px" }}>{Constants.REMEMBER_DEVICE_INFO}</span>
                            </span>
                        </label>
                    </Alert>
                </div>
                <br />

                {/* Buttons */}

                <div className="bottom-buttons">
                    <div className="return-button">
                        <NavLink className="return-logo" to="/enter_wallet_name">
                            <ButtonPrimaryOutlined>
                                Back
                            </ButtonPrimaryOutlined>
                        </NavLink>
                    </div>
                    <div className="next-button">
                        <ButtonPrimary onClick={this.handleContinue} style={nextbuttonstyle}>
                            Next
                        </ButtonPrimary>
                    </div>
                </div>

                {/* BackupChoiceModal — non-dismissible, opens on "Next" */}
                <BackupChoiceModal
                    show={this.state.showBackupModal}
                    password={this.state.password}
                    walletname={this.context.pending_wallet ? this.context.pending_wallet.walletname : ""}
                    address_owner={this.context.address_owner}
                    passwordWasGenerated={this.state.passwordWasGenerated}
                    generateBackupFile={(pw) => this.context.generateBackupFile(pw, this.context.pending_wallet ? this.context.pending_wallet.mnemonic : "")}
                    onComplete={this.handleBackupComplete}
                />

                {/* make it easier to scroll if needed */}
                <div style={{ height: "40vh" }}>&nbsp;</div>

            </div>
        )
    }
}

export default Wallet_Password;
